import React from 'react';
import Modal from 'components/Modal';
import useIsBlockingActionInProgress from '../useIsBlockingActionInProgress';

export type SocialShareModalFooterCancelButtonProps = {
  onCancel: () => void;
};

const SocialShareModalFooterCancelButton: React.FC<SocialShareModalFooterCancelButtonProps> = ({
  onCancel,
}) => {
  const isBlockingActionInProgress = useIsBlockingActionInProgress();

  return (
    <Modal.FooterButton
      disabled={isBlockingActionInProgress}
      onClick={onCancel}
    >
      cancel
    </Modal.FooterButton>
  );
};

export default SocialShareModalFooterCancelButton;
